const SESSION_ID_KEY = "dashboard-session-id";

/**
 * Per-tab session id for usage logging: generated once per browser tab
 * (sessionStorage) so page views and API requests can be correlated.
 * Returns null on the server or when sessionStorage is unavailable.
 */
export const getSessionId = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    let id = window.sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      window.sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    // sessionStorage can throw (e.g. blocked storage) — logging is best-effort.
    return null;
  }
};
